module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Temperature-empty-65fef4a6b49c4fe4c585f0c41abbde73.svg";